var _path, _path2, _g, _g2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle, _circle2, _path21, _path22, _path23, _circle3, _path24, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechnicalIssue1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 263,
    viewBox: "0 0 303 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.153 242.146C218.501 242.146 269.854 190.793 269.854 127.445C269.854 64.0975 218.501 12.7441 155.153 12.7441C91.8055 12.7441 40.4521 64.0975 40.4521 127.445C40.4521 190.793 91.8055 242.146 155.153 242.146Z",
    fill: "url(#paint0_linear_519_112520)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.73925 71.7143C22.8406 59.6437 45.6121 57.3457 67.4146 58.0681C70.5299 58.1714 72.9717 60.7805 72.8685 63.8958C72.7652 67.0112 70.1561 69.4529 67.0408 69.3497C46.1164 68.6564 25.9228 70.9594 8.55023 81.3914C5.87797 82.996 2.41084 82.1306 0.806185 79.4583C-0.798473 76.786 0.0669914 73.3189 2.73925 71.7143Z",
    fill: "url(#paint1_linear_519_112520)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_519_112520)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.689,
    cy: 110.742,
    rx: 69.1592,
    ry: 11.8183,
    fill: "#C4C1FE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_519_112520)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.997,
    cy: 109.867,
    rx: 31.5156,
    ry: 11.8183,
    fill: "#40DFF0",
    fillOpacity: 0.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_519_112520)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.71,
    cy: 228.926,
    rx: 69.1592,
    ry: 11.8183,
    fill: "#C4C1FE"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.071 163.421C303.675 166.093 302.81 169.56 300.137 171.165C280.038 183.234 257.255 185.533 235.454 184.811C232.339 184.708 229.897 182.099 230 178.984C230.103 175.868 232.712 173.426 235.828 173.529C256.752 174.222 276.957 171.918 294.327 161.488C296.999 159.883 300.466 160.749 302.071 163.421Z",
    fill: "url(#paint2_linear_519_112520)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.089 228.191H204.415C223.636 228.191 239.221 207.373 239.221 181.686C239.221 155.998 223.636 135.172 204.415 135.172H147.089C158.981 135.172 169.479 143.138 175.752 155.329C179.788 163.537 181.887 172.563 181.887 181.71C181.887 190.857 179.788 199.882 175.752 208.091C169.479 220.25 158.981 228.191 147.089 228.191Z",
    fill: "url(#paint3_linear_519_112520)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.305 152.25C181.307 138.68 169.592 129.795 156.328 129.795H143.517C122.07 129.795 104.679 153.032 104.679 181.686C104.679 210.341 122.07 233.57 143.517 233.578H156.369C169.632 233.578 181.363 224.709 188.345 211.123C192.846 201.966 195.186 191.898 195.186 181.695C195.186 171.491 192.846 161.423 188.345 152.266L188.305 152.25Z",
    fill: "url(#paint4_linear_519_112520)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.349 152.25C168.366 138.704 156.675 129.827 143.436 129.795C122.006 129.795 104.639 153.048 104.639 181.686C104.639 210.325 122.006 233.546 143.436 233.578C156.675 233.578 168.366 224.709 175.349 211.123C179.855 201.968 182.198 191.899 182.198 181.695C182.198 171.49 179.855 161.422 175.349 152.266V152.25Z",
    fill: "url(#paint5_linear_519_112520)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.551 172.119C146.618 175.518 143.382 177.744 139.719 177.744H136.18C130.256 177.744 125.452 171.923 125.452 164.744C125.452 157.565 130.256 151.746 136.18 151.744H139.73C143.393 151.744 146.634 153.966 148.563 157.37C149.806 159.664 150.452 162.186 150.452 164.742C150.452 167.298 149.806 169.821 148.563 172.115L148.551 172.119Z",
    fill: "url(#paint6_linear_519_112520)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M148.551 207.119C146.618 210.518 143.382 212.744 139.719 212.744H136.18C130.256 212.744 125.452 206.923 125.452 199.744C125.452 192.565 130.256 186.746 136.18 186.744H139.73C143.393 186.744 146.634 188.966 148.563 192.37C149.806 194.664 150.452 197.186 150.452 199.742C150.452 202.298 149.806 204.821 148.563 207.115L148.551 207.119Z",
    fill: "url(#paint7_linear_519_112520)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.598 172.119C142.707 175.512 139.542 177.736 135.957 177.744C130.154 177.744 125.452 171.919 125.452 164.744C125.452 157.569 130.154 151.752 135.957 151.744C139.542 151.744 142.707 153.966 144.598 157.37C145.818 159.663 146.452 162.186 146.452 164.742C146.452 167.299 145.818 169.821 144.598 172.115V172.119Z",
    fill: "#958FFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M144.598 207.119C142.707 210.512 139.542 212.736 135.957 212.744C130.154 212.744 125.452 206.919 125.452 199.744C125.452 192.569 130.154 186.752 135.957 186.744C139.542 186.744 142.707 188.966 144.598 192.37C145.818 194.663 146.452 197.186 146.452 199.742C146.452 202.299 145.818 204.821 144.598 207.115V207.119Z",
    fill: "#958FFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M155.788 114.109H98.4622C79.2407 114.109 63.6475 93.2914 63.6475 67.6036C63.6475 41.9158 79.2407 21.0898 98.4622 21.0898H155.788C143.896 21.0898 133.398 29.0558 127.125 41.2466C123.011 49.4305 120.905 58.4764 120.981 67.6358C120.905 76.7927 123.011 85.836 127.125 94.017C133.398 106.143 143.896 114.109 155.788 114.109Z",
    fill: "url(#paint8_linear_519_112520)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114.564 38.1988C121.571 24.6292 133.286 15.7441 146.549 15.7441H159.401C180.848 15.7441 198.239 38.9809 198.239 67.6357C198.239 96.2905 180.848 119.519 159.401 119.527H146.549C133.286 119.527 121.554 110.658 114.564 97.0726C109.983 87.9409 107.637 77.8516 107.719 67.6357C107.637 57.4198 109.983 47.3305 114.564 38.1988Z",
    fill: "url(#paint9_linear_519_112520)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M127.52 38.1988C134.511 24.6534 146.193 15.7764 159.44 15.7441C180.871 15.7441 198.238 38.997 198.238 67.6357C198.238 96.2744 180.871 119.495 159.44 119.519C146.193 119.519 134.511 110.65 127.52 97.0726C122.939 87.9409 120.593 77.8516 120.675 67.6357C120.593 57.4198 122.939 47.3305 127.52 38.1988Z",
    fill: "url(#paint10_linear_519_112520)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M162.778 58.7502C166.969 58.7502 170.365 54.0358 170.365 48.2203C170.365 42.4048 166.969 37.6904 162.778 37.6904C158.588 37.6904 155.191 42.4048 155.191 48.2203C155.191 54.0358 158.588 58.7502 162.778 58.7502Z",
    fill: "url(#paint11_linear_519_112520)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M162.952 60.7441C168.199 60.7441 172.452 55.1477 172.452 48.2441C172.452 41.3406 168.199 35.7441 162.952 35.7441C157.705 35.7441 153.452 41.3406 153.452 48.2441C153.452 55.1477 157.705 60.7441 162.952 60.7441Z",
    fill: "#7F79F6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M162.952 100.744C168.199 100.744 172.452 95.1477 172.452 88.2441C172.452 81.3406 168.199 75.7441 162.952 75.7441C157.705 75.7441 153.452 81.3406 153.452 88.2441C153.452 95.1477 157.705 100.744 162.952 100.744Z",
    fill: "#7F79F6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6086 138.025C50.1262 135.881 53.1758 135.881 53.6934 138.025L55.4353 145.241C55.6202 146.007 56.2185 146.606 56.9846 146.791L64.2007 148.532C66.3447 149.05 66.3447 152.1 64.2007 152.617L56.9846 154.359C56.2185 154.544 55.6202 155.142 55.4353 155.908L53.6934 163.124C53.1758 165.269 50.1262 165.269 49.6086 163.124L47.8667 155.908C47.6818 155.142 47.0836 154.544 46.3174 154.359L39.1014 152.617C36.9573 152.1 36.9573 149.05 39.1014 148.532L46.3174 146.791C47.0836 146.606 47.6818 146.007 47.8667 145.241L49.6086 138.025Z",
    fill: "url(#paint12_linear_519_112520)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M162.778 58.7502C166.969 58.7502 170.365 54.0358 170.365 48.2203C170.365 42.4048 166.969 37.6904 162.778 37.6904C158.588 37.6904 155.191 42.4048 155.191 48.2203C155.191 54.0358 158.588 58.7502 162.778 58.7502Z",
    fill: "url(#paint13_linear_519_112520)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M162.778 98.7502C166.969 98.7502 170.365 94.0358 170.365 88.2203C170.365 82.4048 166.969 77.6904 162.778 77.6904C158.588 77.6904 155.191 82.4048 155.191 88.2203C155.191 94.0358 158.588 98.7502 162.778 98.7502Z",
    fill: "url(#paint14_linear_519_112520)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M223.82 8.46073C224.337 6.31671 227.387 6.3167 227.904 8.46073L229.646 15.6767C229.831 16.4429 230.429 17.0411 231.196 17.2261L238.412 18.968C240.556 19.4856 240.556 22.5352 238.412 23.0528L231.196 24.7947C230.429 24.9796 229.831 25.5778 229.646 26.344L227.904 33.56C227.387 35.7041 224.337 35.7041 223.82 33.56L222.078 26.344C221.893 25.5778 221.294 24.9796 220.528 24.7947L213.312 23.0528C211.168 22.5352 211.168 19.4856 213.312 18.968L220.528 17.2261C221.294 17.0411 221.893 16.4429 222.078 15.6767L223.82 8.46073Z",
    fill: "url(#paint15_linear_519_112520)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.6515,
    cy: 98.9239,
    r: 4.81488,
    stroke: "url(#paint16_linear_519_112520)",
    strokeWidth: 2.6263
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.58,
    cy: 210.872,
    r: 4.81488,
    stroke: "url(#paint17_linear_519_112520)",
    strokeWidth: 2.6263
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M246.008 131.614C245.675 130.308 246.881 129.131 248.179 129.496L256.937 131.957C258.235 132.322 258.651 133.954 257.686 134.896L251.176 141.25C250.211 142.192 248.589 141.736 248.256 140.43L246.008 131.614Z",
    fill: "url(#paint18_linear_519_112520)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3749 216.247C89.6814 215.916 90.8566 217.123 90.4903 218.42L88.0177 227.175C87.6514 228.472 86.0183 228.886 85.0781 227.921L78.7321 221.402C77.792 220.436 78.2498 218.814 79.5563 218.483L88.3749 216.247Z",
    fill: "url(#paint19_linear_519_112520)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M277.202 82.4137C276.363 88.737 273.934 94.7443 270.143 99.8741C266.352 105.004 261.322 109.088 255.523 111.746C249.724 114.404 243.346 115.548 236.986 115.071C230.625 114.595 224.489 112.513 219.151 109.021L204.638 113.963C204.197 114.11 203.724 114.128 203.274 114.013C202.824 113.898 202.416 113.656 202.1 113.316C201.783 112.976 201.572 112.552 201.49 112.095C201.408 111.638 201.46 111.167 201.639 110.738L207.476 96.8057C204.388 91.6377 202.583 85.8058 202.21 79.7974C201.837 73.789 202.908 67.7786 205.333 62.2686C207.758 56.7586 211.466 51.9091 216.149 48.1254C220.831 44.3416 226.351 41.7337 232.247 40.5194C238.143 39.3051 244.245 39.5198 250.041 41.1456C255.837 42.7713 261.16 45.7609 265.565 49.8644C269.97 53.9679 273.328 59.0661 275.36 64.733C277.391 70.3998 278.037 76.4706 277.243 82.4379L277.202 82.4137Z",
    fill: "url(#paint20_linear_519_112520)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.58,
    cy: 6.87217,
    r: 4.81488,
    stroke: "url(#paint21_linear_519_112520)",
    strokeWidth: 2.6263
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M239.503 97.0602C243.019 97.0602 245.475 94.6604 245.475 91.3119C245.475 87.9076 243.019 85.5078 239.503 85.5078C236.043 85.5078 233.532 87.9076 233.532 91.3119C233.532 94.6604 236.043 97.0602 239.503 97.0602ZM244.972 56.0965H234.034V67.0351L236.824 82.1593H242.126L244.972 67.0351V56.0965Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 93.4521,
    y: 155.744,
    width: 50,
    height: 18,
    rx: 9,
    fill: "url(#paint22_linear_519_112520)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 93.4521,
    y: 190.744,
    width: 50,
    height: 18,
    rx: 9,
    fill: "url(#paint23_linear_519_112520)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_519_112520",
    x: 37.6445,
    y: 77.038,
    width: 182.09,
    height: 67.4083,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.9429,
    result: "effect1_foregroundBlur_519_112520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_519_112520",
    x: 192.596,
    y: 76.163,
    width: 106.803,
    height: 67.4083,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.9429,
    result: "effect1_foregroundBlur_519_112520"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_519_112520",
    x: 79.665,
    y: 195.222,
    width: 182.09,
    height: 67.4083,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.9429,
    result: "effect1_foregroundBlur_519_112520"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_519_112520",
    x1: 154.269,
    y1: -24.6053,
    x2: 156.619,
    y2: 378.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DB3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_519_112520",
    x1: 64.4523,
    y1: 82.3596,
    x2: 16.5802,
    y2: 35.3108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0869FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_519_112520",
    x1: 235.492,
    y1: 193.033,
    x2: 281.682,
    y2: 224.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0869FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_519_112520",
    x1: 225.693,
    y1: 199.925,
    x2: 167.036,
    y2: 89.1868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0869FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_519_112520",
    x1: 181.896,
    y1: 202.041,
    x2: 112.008,
    y2: 85.8679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_519_112520",
    x1: 111.417,
    y1: 188.415,
    x2: 182.412,
    y2: 187.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_519_112520",
    x1: 154.452,
    y1: 171.744,
    x2: 132.216,
    y2: 140.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_519_112520",
    x1: 154.452,
    y1: 206.744,
    x2: 132.216,
    y2: 175.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_519_112520",
    x1: 87.952,
    y1: 118.36,
    x2: 83.6043,
    y2: -24.8995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0869FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_519_112520",
    x1: 161.953,
    y1: 96.8599,
    x2: 142.452,
    y2: -31.0823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0869FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_519_112520",
    x1: 127.452,
    y1: 74.3599,
    x2: 198.452,
    y2: 73.8599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_519_112520",
    x1: 147.949,
    y1: 59.1415,
    x2: 207.156,
    y2: 54.6685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_519_112520",
    x1: 66.4911,
    y1: 158.816,
    x2: 40.1364,
    y2: 108.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0869FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_519_112520",
    x1: 157.452,
    y1: 40.2437,
    x2: 212.513,
    y2: 55.7786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_519_112520",
    x1: 157.452,
    y1: 80.2437,
    x2: 212.513,
    y2: 95.7786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_519_112520",
    x1: 240.702,
    y1: 29.2516,
    x2: 214.347,
    y2: -20.9823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0869FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_519_112520",
    x1: 55.9798,
    y1: 101.328,
    x2: 48.293,
    y2: 86.6761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0869FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_519_112520",
    x1: 254.909,
    y1: 213.276,
    x2: 247.222,
    y2: 198.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0869FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_519_112520",
    x1: 258.197,
    y1: 133.079,
    x2: 235.719,
    y2: 125.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0869FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_519_112520",
    x1: 86.8942,
    y1: 228.434,
    x2: 94.2324,
    y2: 205.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0869FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_519_112520",
    x1: 201.482,
    y1: 39.9247,
    x2: 239.512,
    y2: 115.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49E2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31D9EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_519_112520",
    x1: 126.909,
    y1: 9.27585,
    x2: 119.222,
    y2: -5.37569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0869FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_519_112520",
    x1: 136.11,
    y1: 168.274,
    x2: 106.661,
    y2: 138.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_519_112520",
    x1: 136.11,
    y1: 203.274,
    x2: 131.106,
    y2: 176.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5149F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicalIssue1);
export default __webpack_public_path__ + "static/media/TechnicalIssue1.ce6ab444c4aa2554d777b9fe710d6b33.svg";
export { ForwardRef as ReactComponent };